import { FC, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik, useFormik } from "formik";
import { DateTime } from "luxon";
import { t } from "i18next";

import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import TableListMatricula from "@/shared/components/organisms/TableListMatricula";
import { InputDropDownSpan } from "@/shared/components/atoms/InputDropDownSpan";
import { TableListFeesCourse } from "@/shared/components/organisms/TableListFeesCourse";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { ModalWithTabs } from "@/shared/components/organisms/ModalTabs";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { currencies, daysOfWeek, Fee, periods } from "@/app/fees/fees";
import PaginationUI from "@/shared/components/atoms/PaginationUI";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { Select } from "@/shared/components/organisms/Select";
import { Modal } from "@/shared/components/organisms/Modal";
import { useDebounce } from "@/shared/hooks/debounce";
import { toasts } from "@/shared/utils/toasts";

import {
  useCreateReasonMutation,
  useReasonsQuery,
} from "@/app/reasons/reasons.api";
import {
  disabledFeeValidationSchema,
  disabledFeeInitialValues,
} from "@/shared/schemas/fees.schema";
import {
  createReasonInitialValue,
  createReasonValidationSchema,
  CreateReasonValues,
} from "@/shared/schemas/reasons.schema";
import { useKpiFeesQuery, useDisabledFeeMutation } from "@/app/fees/fees.api";
import { reasonTypes } from "@/app/reasons/reasons";
import {
  createRegistrationPaymentInitialValues,
  createRegistrationPaymentValidationSchema,
} from "@/shared/schemas/registration-payments.schema";
import { RegistrationPayment } from "@/app/registration-payments/registration-payments";
import {
  useGetListMatriculateCourseQuery,
  useCreateMatriculateCourseMutation,
  useUpdateMatriculateCourseMutation,
} from "@/app/registration-payments/registration-payments.api";

import { configureExporting } from "@/shared/utils/chartUtils";
import {
  useCoursesFeeQuery,
  useCreateCourseFeeMutation,
  useUpdateCourseFeeMutation,
} from "@/app/courses/courses.api";
import {
  CourseFeeValues,
  createCourseFeeInitialValues,
  createCourseFeeValidationSchema,
} from "@/shared/schemas/course.schema";
import { TextArea } from "@/shared/components/atoms/TextArea";

const optionsPeriodo = [
  { id: 1, name: "Semanal", value: "weekly" },
  { id: 3, name: "Mensual", value: "month" },
  { id: 5, name: "Trimestral", value: "quarterly" },
  { id: 4, name: "Bianual", value: "biannual" },
  { id: 5, name: "Anual", value: "year" },
];

const tabs = [
  { id: 1, name: t("general.reasons") },
  { id: 2, name: t("general.kpi") },
];

export const CourseFees: FC<any> = () => {
  const { id } = useParams();
  const [search, setSearch] = useState<string | undefined>();
  const [currentFee, setCurrentFee] = useState<CourseFeeValues | undefined>();
  const [currentRegistrationPaymentEdit, setCurrentRegistrationPaymentEdit] =
    useState<RegistrationPayment | undefined>();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  const reasonsQuery = useReasonsQuery({ branchId: id });
  const [createReason, createReasonResult] = useCreateReasonMutation();
  const debouncedSearch = useDebounce(search, 200);

  const listMatriculateCourseQuery = useGetListMatriculateCourseQuery({
    branchId: id,
  });

  const [createRegistrationPayment, createRegistrationPaymentResult] =
    useCreateMatriculateCourseMutation();
  const [updateRegistrationPayment, updateRegistrationPaymentResult] =
    useUpdateMatriculateCourseMutation();

  const coursesFeeQuery = useCoursesFeeQuery({
    branchId: id,
    search: debouncedSearch,
    page: debouncedSearch ? 1 : page,
  });

  const [createCourseFee, createCourseFeeResult] = useCreateCourseFeeMutation();
  const [updateCourseFee, updateCourseFeeResult] = useUpdateCourseFeeMutation();
  //const [updateFee] = useUpdateFeeMutation();
  const [disabledFee, disabledFeeResult] = useDisabledFeeMutation();

  const [initialValues, setInitialValues] = useState(disabledFeeInitialValues);

  const [open, setOpen] = useState(false);
  const [openEditCourseFee, setOpenEditCourseFee] = useState(false);
  const openDialog = () => {
    setOpen(!open);
  };

  const openDialogEditCourseFee = () => {
    setOpenEditCourseFee(!openEditCourseFee);
  };

  useEffect(() => {
    if (currentRegistrationPaymentEdit) {
      setOpenModalCreateMatriculasState(true);
    }
  }, [currentRegistrationPaymentEdit]);

  //CHECKED ACCESSO APP
  const [accessApp, setAccessApp] = useState(true);
  const handleAccessApp = () => {
    setAccessApp(!accessApp);
  };
  //CHECKED ACCESS PLAN NUTRRITION
  const [accessPlanNutrition, setAccessPlanNutrition] = useState(true);
  const handleAccessPlanNutrition = () => {
    setAccessPlanNutrition(!accessPlanNutrition);
  };
  //CHECKED VISIBLE APP
  const [visibleApp, setVisibleApp] = useState(true);
  const handleVisibleApp = () => {
    setVisibleApp(!visibleApp);
  };
  //CHECKED MULTICENTRO
  const [multicentro, setMulticentro] = useState(false);
  const handleMulticentro = () => {
    setMulticentro(!multicentro);
  };
  //SELECT MULTICENTRO
  const [centro, setCentro] = useState([]);
  //SELECT INSTALACIONES
  const [instalaciones, setInstalaciones] = useState([]);
  //OPEN FOR MODAL MATRICULAS
  const [openModal, setOpenModal] = useState(false);
  const openModalMatriculas = () => {
    setOpenModal(!openModal);
  };
  //OPEN MODAL CREATE MATRICULAS
  const [openModalCreateMatriculasState, setOpenModalCreateMatriculasState] =
    useState(false);
  const openModalCreateMatriculas = () => {
    setOpenModalCreateMatriculasState(!openModalCreateMatriculasState);
  };
  //OPEN MODAL PAUSE
  const [openModalPause, setOpenModalPause] = useState(false);
  const openModalPauseState = () => {
    setOpenModalPause(!openModalPause);
  };
  //HANDLE CHANGE DATARANGE
  const handleDateChange = (startDate: Date, endDate: Date) => {
    console.log(
      `Selected range: ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
    );
  };
  //OPEN MODAL MOTIVOS
  const [openModalMotivos, setOpenModalMotivos] = useState(false);
  const openModalMotivosState = () => {
    setOpenModalMotivos(!openModalMotivos);
  };
  //STATE FOR CONTROL OF TABS
  const [selectedTab, setSelectedTab] = useState(1);
  //STATE MODAL CREATE MOTIVOS
  const [openModalCreateMotivosState, setOpenModalCreateMotivosState] =
    useState(false);
  const openModalCreateMotivos = () => {
    setOpenModalCreateMotivosState(!openModalCreateMotivosState);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const agreementsFormik = useFormik({
    initialValues: {
      startDate: DateTime.now().minus({ weeks: 1 }).toFormat("yyyy-MM-dd"),
      endDate: DateTime.now().toFormat("yyyy-MM-dd"),
    },
    onSubmit: () => {},
  });

  const { data: getKpiFeesBranch } = useKpiFeesQuery({
    branchId: id,
    from_date: agreementsFormik.values.startDate,
    to_date: agreementsFormik.values.endDate,
  });

  useEffect(() => {
    if (getKpiFeesBranch && openModalMotivos) {
      const chart1 = createReasonsHigh(
        getKpiFeesBranch,
        getKpiFeesBranch.reasonGrap1.reduce((a, b) => a + b, 0)
      );
      const chart2 = createReasonsLow(
        getKpiFeesBranch,
        getKpiFeesBranch.reasonGrap2.reduce((a, b) => a + b, 0)
      );
      return () => {
        chart1.dispose();
        chart2.dispose();
      };
    }
  }, [getKpiFeesBranch]);

  const createReasonsHigh = (
    data: { reasonGrap1: number[]; reasonLabel1: string[] },
    totalSum: number
  ): am5.Root => {
    const root = am5.Root.new("reason_high");

    root.setThemes([am5themes_Animated.new(root)]);
    if (root._logo) {
      root._logo.dispose();
    }

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(50),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
      })
    );

    series.children.push(
      am5.Label.new(root, {
        centerX: am5.percent(50),
        centerY: am5.percent(50),
        text: "Total: " + totalSum,
        populateText: true,
        fontSize: "1.2em",
      })
    );

    series.labels.template.setAll({
      forceHidden: true,
    });

    series.slices.template.set(
      "tooltipText",
      "{category} - Total: [bold]{value}[/]"
    );

    // Transformar los datos
    const transformedData = data.reasonGrap1.map((value, index) => ({
      category: data.reasonLabel1[index],
      value: value,
    }));

    series.data.setAll(transformedData);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15,
      })
    );

    // Configurar las etiquetas de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.labels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    // Configurar los valores de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.valueLabels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);

    return root;
  };

  const createReasonsLow = (
    data: { reasonGrap2: number[]; reasonLabel2: string[] },
    totalSum: number
  ): am5.Root => {
    const root = am5.Root.new("reasons_low");

    root.setThemes([am5themes_Animated.new(root)]);
    if (root._logo) {
      root._logo.dispose();
    }

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(50),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
      })
    );

    series.children.push(
      am5.Label.new(root, {
        centerX: am5.percent(50),
        centerY: am5.percent(50),
        text: "Total: " + totalSum,
        populateText: true,
        fontSize: "1.2em",
      })
    );

    series.labels.template.setAll({
      forceHidden: true,
    });

    series.slices.template.set(
      "tooltipText",
      "{category} - Total: [bold]{value}[/]"
    );

    // Transformar los datos
    const transformedData = data.reasonGrap2.map((value, index) => ({
      category: data.reasonLabel2[index],
      value: value,
    }));

    series.data.setAll(transformedData);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15,
      })
    );

    // Configurar las etiquetas de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.labels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    // Configurar los valores de la leyenda para que sean de color gris y tamaño de fuente 11
    legend.valueLabels.template.setAll({
      fontSize: 14,
      fontWeight: "300",
      fill: am5.color(0x6b7280), // text-gray-500
    });

    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);

    setIsLoading(false);

    configureExporting(root, transformedData);

    return root;
  };

  const copyValueFromArray = (fee: Fee) => {
    const link = `/register/user?${fee.id}-${fee.id}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toasts.success("Link", "¡Link copiado!");
      })
      .catch((err) => {
        console.error("Error al copiar al portapapeles: ", err);
      });
  };

  const handleCreateCourseFee = async (values: CourseFeeValues) => {
    try {
      await createCourseFee({ ...values, branchId: id }).unwrap();
      toasts.success(
        "Registro exitoso",
        "La cuota se ha registrado correctamente"
      );
    } catch (error) {
      throw error;
    }
  };

  const handleUpdateCourseFee = async (values: CourseFeeValues) => {
    try {
      await updateCourseFee({
        ...values,
        branchId: id,
        id: currentFee?.id ?? 0,
      }).unwrap();
      toasts.success(
        "Actualización exitosa",
        "La cuota se ha actualizado correctamente"
      );
      coursesFeeQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar la cuota"
      );
    }
  };

  const handleCreateMatriculas = async (values: CourseFeeValues) => {
    try {
      await createRegistrationPayment({ ...values, branchId: id }).unwrap();
      toasts.success(
        "Registro exitoso",
        "La matrícula se ha registrado correctamente"
      );
      listMatriculateCourseQuery.refetch();
      openModalMatriculas();
    } catch (error) {
      toasts.danger(
        "Error al registrar",
        "Ha ocurrido un error al registrar la matrícula"
      );
      throw error;
    }
  };

  const handleUpdateMatriculas = async (values: CourseFeeValues) => {
    try {
      await updateRegistrationPayment({
        ...values,
        branchId: id,
        id: currentRegistrationPaymentEdit?.id,
      }).unwrap();

      toasts.success(
        "Actualización exitosa",
        "La matrícula se ha actualizado correctamente"
      );
      listMatriculateCourseQuery.refetch();
      openModalMatriculas();
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar la matrícula"
      );
      throw error;
    }
  };

  const handleDisabledFee = async (values: CourseFeeValues) => {
    try {
      await disabledFee({ ...values, branchId: id }).unwrap();
      openModalPauseState();
      toasts.success("Pausa exitosa", "La cuota se ha pausado correctamente");
      await coursesFeeQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al pausar",
        "Ha ocurrido un error al pausar la cuota"
      );
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col flex-1 overflow-y-scroll w-full pt-5">
      <div className="flex flex-1 flex-col w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto">
        <TableListFeesCourse
          isLoading={coursesFeeQuery?.isLoading}
          onSearchChange={(event) => setSearch(event.target.value)}
          onEditFee={(fee) => {
            setCurrentFee(fee as unknown as CourseFeeValues);
            openDialogEditCourseFee();
          }}
          search={search}
          title={t("customer-to-gym-subscription.views.title")}
          description={t("customer-to-gym-subscription.views.subtittle")}
          fees={coursesFeeQuery?.data ?? []}
          functionButtonCreate={openDialog}
          functionButtonMatriculas={openModalMatriculas}
          functionButtonPause={(fee) => {
            openModalPauseState();
            setInitialValues({
              dateInitial: fee.date_init_pause ?? "",
              dateEnd: fee.date_end_pause ?? "",
              days: "0",
              fee_id: fee.id,
            });
          }}
          functionButtonLink={(fee) => copyValueFromArray(fee)}
          functionButtonMotivos={openModalMotivosState}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          currentPage={page}
        />
        {coursesFeeQuery.data && (
          <PaginationUI
            onPageChange={(event) => handlePageChange(event)}
            currentPage={page}
            pageSize={pageSize}
            totalResults={coursesFeeQuery.data.length}
            totalPages={Math.ceil(
              (coursesFeeQuery?.data.length ?? 0) / pageSize
            )}
          />
        )}

        {/*DIALOG CREATE COUTAS*/}
        <Formik
          initialValues={createCourseFeeInitialValues}
          validationSchema={createCourseFeeValidationSchema}
          enableReinitialize
          onSubmit={async (values: CourseFeeValues, formikHelpers) => {
            try {
              await handleCreateCourseFee(values);
            } catch (error) {
              toasts.danger(
                "Error al registrar",
                "Ha ocurrido un error al registrar la cuota"
              );
            } finally {
              formikHelpers.resetForm();
              setOpen(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            values,
            handleSubmit,
            resetForm,
            errors,
            touched,
            isValid,
          }) => (
            <DialogCreate
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                setOpen(false);
                resetForm();
              }}
              onClose={() => {
                setOpen(false);
                resetForm();
              }}
              tittleButtonCreate={t("general.create")}
              tittleButtonCancel={t("general.cancel")}
              open={open}
              setOpen={setOpen}
              tittle={t("customer-to-gym-subscription.views.create_fee")}
              subTittle={t("customer-to-gym-subscription.views.creation_fee")}
              isLoading={createCourseFeeResult.isLoading}
              acceptDisabled={createCourseFeeResult.isLoading || !isValid}
            >
              <div>
                <div className="space-y-12 pr-4">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t(
                            "customer-to-gym-subscription.views.principal_caracteristics"
                          )}
                        </h2>
                      </div>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("customer-to-gym-subscription.views.name")}
                          name="name"
                          span={t("general.mandatory")}
                          type="text"
                          placeholder={t(
                            "customer-to-gym-subscription.views.name"
                          )}
                          onChange={handleChange}
                          error={errors?.name && touched?.name}
                          textError={errors?.name}
                          value={values.name}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.description"
                          )}
                          span={t("general.mandatory")}
                          name="description"
                          error={errors?.description && touched?.description}
                          textError={errors?.description}
                          onChange={handleChange}
                          value={values.description}
                          type="text"
                          placeholder={t(
                            "customer-to-gym-subscription.views.description"
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("customer-to-gym-subscription.views.price")}
                        </h2>
                      </div>
                    </div>
                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <Select
                          name="registrationPaymentId"
                          span={t("general.optional")}
                          selected={listMatriculateCourseQuery?.data?.data?.find(
                            (registrationPayment: RegistrationPayment) =>
                              registrationPayment?.id ==
                              values.registration_payment
                          )}
                          setSelected={(option) =>
                            setFieldValue("registration_payment", option.id)
                          }
                          options={listMatriculateCourseQuery?.data?.data}
                          tittle={t(
                            "customer-to-gym-subscription.views.registration"
                          )}
                          error={
                            errors?.registration_payment &&
                            touched?.registration_payment
                          }
                          textError={errors?.registration_payment}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputDropDownSpan
                          label={t("customer-to-gym-subscription.views.mount")}
                          name="amount"
                          type="number"
                          span={t("general.mandatory")}
                          placeholder={t(
                            "customer-to-gym-subscription.views.mount"
                          )}
                          onChange={handleChange}
                          value={values.amount}
                          nameSelect="currency"
                          selectValue={
                            currencies.find(
                              (item) => item.currency == values.currency
                            )?.id
                          }
                          onSelectChange={(event) => {
                            const currencyId = event.target.value;
                            const currency = currencies.find(
                              (item) => item.id == currencyId
                            );
                            setFieldValue("currency", currency?.currency);
                          }}
                          options={currencies.map((item) => ({
                            ...item,
                            text: item.currency,
                          }))}
                          error={errors?.currency && touched?.currency}
                          textError={errors?.currency}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          name="interval"
                          span={t("general.optional")}
                          selected={optionsPeriodo.find(
                            (option) => option.value == values.interval
                          )}
                          setSelected={(option) => {
                            setFieldValue("interval", option.value);
                          }}
                          options={optionsPeriodo}
                          tittle={t(
                            "customer-to-gym-subscription.views.renewal_period"
                          )}
                        />
                      </div>
                      <div className="col-span-full grid grid-cols-2 gap-4 items-center">
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.periot_free"
                          )}
                          name="trial_period_days"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.periot_free"
                          )}
                          onChange={handleChange}
                          error={
                            errors?.trial_period_days &&
                            touched?.trial_period_days
                          }
                          textError={errors?.trial_period_days}
                          value={values.trial_period_days}
                        />
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.number_of_people"
                          )}
                          name="people"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.number_of_people"
                          )}
                          onChange={handleChange}
                          error={!!errors.people}
                          textError={errors.people}
                          value={values.people}
                        />
                      </div>
                      <div className="col-span-full grid grid-cols-2 gap-4 items-center">
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.discount_text"
                          )}
                          name="discount"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.discount_text"
                          ).slice(0, 11)}
                          value={values.discount}
                          onChange={handleChange}
                          error={errors?.discount && touched?.discount}
                          textError={errors?.discount}
                        />
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.discount_period"
                          )}
                          name="repeat_discount"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.discount_period"
                          )}
                          onChange={handleChange}
                          error={
                            errors?.repeat_discount && touched?.repeat_discount
                          }
                          textError={errors?.repeat_discount}
                          value={values.repeat_discount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          )}
        </Formik>

        {/*DIALOG EDIT COUTAS*/}
        <Formik
          initialValues={{
            ...currentFee,
            registration_payment: currentFee?.registration_payment_id,
            amount: currentFee?.price / 100,
          }}
          validationSchema={createCourseFeeValidationSchema}
          enableReinitialize
          onSubmit={async (values: CourseFeeValues, formikHelpers) => {
            try {
              await handleUpdateCourseFee(values);
            } catch (error) {
              toasts.danger(
                "Error al registrar",
                "Ha ocurrido un error al registrar la cuota"
              );
            } finally {
              formikHelpers.resetForm();
              setOpenEditCourseFee(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            values,
            handleSubmit,
            resetForm,
            errors,
            touched,
          }) => (
            <DialogCreate
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                setOpenEditCourseFee(false);
                resetForm();
              }}
              tittleButtonCreate={t("general.edit")}
              tittleButtonCancel={t("general.cancel")}
              open={openEditCourseFee}
              onClose={() => {
                setOpenEditCourseFee(false);
                resetForm();
              }}
              isLoading={updateCourseFeeResult.isLoading}
              acceptDisabled={updateCourseFeeResult.isLoading}
              setOpen={setOpenEditCourseFee}
              tittle={t("customer-to-gym-subscription.views.edit_fee")}
              subTittle={t("customer-to-gym-subscription.views.edit_fee")}
            >
              <div>
                <div className="space-y-12">
                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t(
                            "customer-to-gym-subscription.views.principal_caracteristics"
                          )}
                        </h2>
                      </div>
                    </div>
                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <InputWithCornerHint
                          label={t("customer-to-gym-subscription.views.name")}
                          name="name"
                          type="text"
                          placeholder={t(
                            "customer-to-gym-subscription.views.name"
                          )}
                          onChange={handleChange}
                          error={errors?.name && touched?.name}
                          textError={errors?.name}
                          value={values?.name}
                        />
                      </div>
                      <div className="col-span-full">
                        <TextArea
                          htmlFor="description"
                          label={t(
                            "customer-to-gym-subscription.views.description"
                          )}
                          spanMessage={t("general.mandatory")}
                          name="description"
                          error={errors?.description && touched?.description}
                          textError={errors?.description}
                          onChange={handleChange}
                          value={values?.description}
                          placeholder={t(
                            "customer-to-gym-subscription.views.description"
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div className="flex items-center justify-center h-full text-center">
                      <div>
                        <h2 className="text-base font-semibold leading-7 text-gray-900">
                          {t("customer-to-gym-subscription.views.price")}
                        </h2>
                      </div>
                    </div>
                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                      <div className="col-span-full">
                        <Select
                          name="registrationPaymentId"
                          selected={listMatriculateCourseQuery?.data?.data?.find(
                            (registrationPayment: RegistrationPayment) =>
                              registrationPayment?.id ==
                              values?.registration_payment
                          )}
                          setSelected={(option) => {
                            setFieldValue("registration_payment", option.id);
                          }}
                          options={listMatriculateCourseQuery?.data?.data}
                          tittle={t(
                            "customer-to-gym-subscription.views.registration"
                          )}
                          error={
                            errors?.registration_payment &&
                            touched?.registration_payment
                          }
                          textError={errors?.registration_payment}
                        />
                      </div>
                      <div className="col-span-full">
                        <InputDropDownSpan
                          label={t("customer-to-gym-subscription.views.mount")}
                          name="amount"
                          id="amount"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.mount"
                          )}
                          onChange={handleChange}
                          value={values?.amount}
                          nameSelect="currency"
                          selectValue={
                            currencies.find(
                              (item) => item.currency == values?.currency
                            )?.id
                          }
                          onSelectChange={(event: any) => {
                            const currencyId = event.target.value;
                            const currency = currencies.find(
                              (item) => item.id == currencyId
                            );
                            setFieldValue("currency", currency?.currency);
                          }}
                          options={currencies.map((item) => ({
                            ...item,
                            text: item.currency,
                          }))}
                          error={errors?.currency && touched?.currency}
                          textError={errors?.currency}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                          name="interval"
                          selected={optionsPeriodo.find(
                            (option) => option.value == values?.interval
                          )}
                          setSelected={(option) =>
                            setFieldValue("interval", option.value)
                          }
                          options={optionsPeriodo}
                          tittle={t(
                            "customer-to-gym-subscription.views.renewal_period"
                          )}
                        />
                      </div>
                      <div className="col-span-full grid grid-cols-2 gap-4 items-center">
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.periot_free"
                          )}
                          name="trial_period_days"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.periot_free"
                          )}
                          onChange={handleChange}
                          error={
                            errors?.trial_period_days &&
                            touched?.trial_period_days
                          }
                          textError={errors?.trial_period_days}
                          value={values?.trial_period_days}
                        />
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.number_of_people"
                          )}
                          name="people"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.number_of_people"
                          )}
                          onChange={handleChange}
                          error={errors?.people && touched?.people}
                          textError={errors?.people}
                          value={values?.people}
                        />
                      </div>
                      <div className="col-span-full grid grid-cols-2 gap-4 items-center">
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.discount_text"
                          )}
                          name="discount"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.discount_text"
                          ).slice(0, 11)}
                          value={values?.discount}
                          onChange={handleChange}
                          error={errors?.discount && touched?.discount}
                          textError={errors?.discount}
                        />
                        <InputWithCornerHint
                          label={t(
                            "customer-to-gym-subscription.views.discount_period"
                          )}
                          name="repeat_discount"
                          type="number"
                          placeholder={t(
                            "customer-to-gym-subscription.views.discount_period"
                          )}
                          onChange={handleChange}
                          error={
                            errors?.repeat_discount && touched?.repeat_discount
                          }
                          textError={errors?.repeat_discount}
                          value={values?.repeat_discount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogCreate>
          )}
        </Formik>

        {/* Modal matriculas table*/}
        <ModalXXL
          open={openModal}
          Close={openModalMatriculas}
          tittleModal={t("customer-to-gym-subscription.views.registrations")}
          textButtonClose={t("general.close")}
          functionButtonTopCreate={openModalCreateMatriculas}
          modalClassName="z-50"
        >
          <TableListMatricula
            onEdit={(registrationPayment) =>
              setCurrentRegistrationPaymentEdit(registrationPayment)
            }
            registrationPayments={listMatriculateCourseQuery?.data?.data}
          />
        </ModalXXL>

        {/* Modal matriculas create*/}
        <Formik
          enableReinitialize
          validationSchema={createRegistrationPaymentValidationSchema}
          initialValues={
            currentRegistrationPaymentEdit ??
            createRegistrationPaymentInitialValues
          }
          onSubmit={async (values, formikHelpers) => {
            if (currentRegistrationPaymentEdit) {
              await handleUpdateMatriculas(
                values as unknown as CourseFeeValues
              );
            } else {
              await handleCreateMatriculas(
                values as unknown as CourseFeeValues
              );
            }
            setCurrentRegistrationPaymentEdit(undefined);
            openModalCreateMatriculas();
            formikHelpers.resetForm();
          }}
        >
          {({
            handleChange,
            values,
            errors,
            touched,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <Modal
              open={openModalCreateMatriculasState}
              Close={() => {
                openModalCreateMatriculas();
                resetForm();
                setCurrentRegistrationPaymentEdit(undefined);
              }}
              tittleModal={t("customer-to-gym-subscription.views.registration")}
              onClickCreate={handleSubmit}
              onClose={() => {
                setCurrentRegistrationPaymentEdit(undefined);
                openModalCreateMatriculas();
                resetForm();
              }}
              loader={
                createRegistrationPaymentResult.isLoading ||
                updateRegistrationPaymentResult.isLoading
              }
              textButtonCreate={
                currentRegistrationPaymentEdit
                  ? t("general.edit")
                  : t("general.create")
              }
              textButtonClose={t("general.cancel")}
            >
              <div className="col-span-full mt-5">
                <InputWithCornerHint
                  label={t("customer-to-gym-subscription.views.name")}
                  name="name"
                  type="text"
                  placeholder={t("customer-to-gym-subscription.views.name")}
                  onChange={handleChange}
                  error={!!errors.name}
                  textError={errors.name}
                  value={values.name}
                />
              </div>
              <div className="col-span-full mt-5">
                <InputDropDownSpan
                  label={t("customer-to-gym-subscription.views.mount")}
                  id=""
                  name="price"
                  type="number"
                  value={values.price}
                  selectValue={
                    currencies.find((item) => item.currency == values?.currency)
                      ?.id
                  }
                  onChange={handleChange}
                  placeholder={t("customer-to-gym-subscription.views.mount")}
                  idSelect={
                    currencies.find((item) => item.currency == values?.currency)
                      ?.currency
                  }
                  labelSelect={values?.currency}
                  nameSelect="currency"
                  onSelectChange={(event) => {
                    const currencyId = event.target.value;
                    const currency = currencies.find(
                      (item) => item.id == currencyId
                    );
                    setFieldValue("currency", currency?.currency);
                  }}
                  options={currencies.map((item) => ({
                    ...item,
                    text: item.currency,
                  }))}
                  error={errors?.currency && touched?.currency}
                  textError={errors?.currency}
                />
              </div>
            </Modal>
          )}
        </Formik>

        {/* Modal Pause cuota curos*/}
        <Formik
          enableReinitialize
          validationSchema={disabledFeeValidationSchema}
          initialValues={{ ...initialValues, days: initialValues.days || 0 }}
          onSubmit={async (values, formikHelpers) => {
            try {
              await handleDisabledFee(values as unknown as CourseFeeValues);
              listMatriculateCourseQuery.refetch();
              formikHelpers.resetForm();
              await coursesFeeQuery.refetch();
            } catch (error) {
              console.error(error);
            }
          }}
        >
          {({ values, handleSubmit, setFieldValue, errors }) => (
            <Modal
              open={openModalPause}
              Close={openModalPauseState}
              tittleModal={t("customer-to-gym-subscription.views.pause")}
              textButtonCreate={t("general.accept")}
              textButtonClose={t("general.cancel")}
              onClickCreate={handleSubmit}
              loader={disabledFeeResult.isLoading}
            >
              <p className="text-sm text-gray-900 mt-5">
                {t("customer-to-gym-subscription.views.pause_description1")}
              </p>
              <p className="text-sm text-red-500 mt-5">
                {t("customer-to-gym-subscription.views.pause_description2")}
              </p>
              <div className="col-span-full mt-5 mb-10">
                <DateRangePicker
                  id="date"
                  label={t("customer-to-gym-subscription.views.interval_date")}
                  onDateChange={(startDate, endDate) => {
                    const startDateFormatted =
                      DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd");
                    const endDateFormatted =
                      DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd");
                    setFieldValue("dateInitial", startDateFormatted);
                    setFieldValue("dateEnd", endDateFormatted);
                  }}
                  value={{
                    startDate: values.dateInitial
                      ? DateTime.fromFormat(
                          values.dateInitial,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                    endDate: values.dateEnd
                      ? DateTime.fromFormat(
                          values.dateEnd,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                  }}
                />
              </div>
            </Modal>
          )}
        </Formik>

        {/* Modal MOTIVOS TABS*/}
        <ModalWithTabs
          open={openModalMotivos}
          Close={openModalMotivosState}
          textButtonClose={t("general.close")}
          functionButtonTopCreate={openModalCreateMotivos}
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        >
          <div className="mt-6">
            {selectedTab === 1 && (
              <div>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                  <div className="pb-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t("customer-to-gym-subscription.views.motive_up")}
                    </h3>
                    {reasonsQuery?.data
                      ?.filter(({ type }: any) => type == 1)
                      .map((reason: any) => (
                        <ul className="space-y-2 mt-4 text-sm text-gray-500">
                          <li>{reason.description}</li>
                        </ul>
                      ))}
                  </div>

                  <div className="pb-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {t("customer-to-gym-subscription.views.motive_up")}
                    </h3>
                    {reasonsQuery?.data
                      ?.filter(({ type }: any) => type == 2)
                      .map((reason: any) => (
                        <ul className="space-y-2 mt-4 text-sm text-gray-500">
                          <li>{reason.description}</li>
                        </ul>
                      ))}
                  </div>
                </div>
              </div>
            )}
            {selectedTab === 2 && (
              <>
                <DateRangePicker
                  id="agreements-date"
                  label={t("lesson.views.interval_date")}
                  value={{
                    startDate: agreementsFormik.values.startDate
                      ? DateTime.fromFormat(
                          agreementsFormik.values.startDate,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                    endDate: agreementsFormik.values.endDate
                      ? DateTime.fromFormat(
                          agreementsFormik.values.endDate,
                          "yyyy-MM-dd"
                        ).toJSDate()
                      : new Date(),
                  }}
                  onDateChange={(startDate, endDate) => {
                    setIsLoading(true);
                    agreementsFormik.setFieldValue(
                      "startDate",
                      DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")
                    );
                    agreementsFormik.setFieldValue(
                      "endDate",
                      DateTime.fromJSDate(endDate).toFormat("yyyy-MM-dd")
                    );
                  }}
                />

                <div className="mt-10">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="border-b border-gray-200 pb-4">
                      <h3 className="text-lg font-semibold text-gray-800">
                        {t("customer-to-gym-subscription.views.motive_up")}
                      </h3>
                      <div className="mt-4 bg-gray-100 p-4 rounded-lg">
                        {isLoading && (
                          <div className="flex justify-center items-center h-90 mt-20">
                            <FontAwesomeIcon
                              icon={faLoader}
                              spin
                              className="text-6xl"
                            />
                          </div>
                        )}
                        <div
                          id="reason_high"
                          style={{ width: "100%", height: "400px" }}
                        ></div>
                      </div>
                    </div>

                    <div className="border-b border-gray-200 pb-4">
                      <h3 className="text-lg font-semibold text-gray-800">
                        {t("customer-to-gym-subscription.views.motive_down")}
                      </h3>
                      <div className="mt-4 bg-gray-100 p-4 rounded-lg">
                        {isLoading && (
                          <div className="flex justify-center items-center h-90 mt-20">
                            <FontAwesomeIcon
                              icon={faLoader}
                              spin
                              className="text-6xl"
                            />
                          </div>
                        )}
                        <div
                          id="reasons_low"
                          style={{ width: "100%", height: "400px" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </ModalWithTabs>

        {/* Modal MOTIVOS TABS*/}
        <Formik
          initialValues={createReasonInitialValue}
          validationSchema={createReasonValidationSchema}
          onSubmit={(values: CreateReasonValues, formikHelpers) => {
            createReason({ ...values, branchId: id });
            formikHelpers.resetForm();
          }}
        >
          {({ handleChange, values, errors, setFieldValue, handleSubmit }) => (
            <Modal
              open={openModalCreateMotivosState}
              Close={openModalCreateMotivos}
              textButtonCreate={t("general.accept")}
              textButtonClose={t("general.cancel")}
              onClickCreate={handleSubmit}
              tittleModal={t(
                "customer-to-gym-subscription.views.create_reason"
              )}
            >
              <div className="col-span-full mt-5">
                <InputWithCornerHint
                  label={t("customer-to-gym-subscription.views.motive")}
                  name="description"
                  type="text"
                  placeholder={t("customer-to-gym-subscription.views.motive")}
                  onChange={handleChange}
                  error={!!errors.description}
                  value={values.description}
                />
              </div>
              <div className="col-span-full mt-5">
                <Select
                  name="type"
                  selected={reasonTypes.find(
                    (reasonType) => reasonType.value == values.type
                  )}
                  setSelected={(option: any) =>
                    setFieldValue("type", option?.value)
                  }
                  options={reasonTypes}
                  tittle={t(
                    "customer-to-gym-subscription.views.description_reason"
                  )}
                />
              </div>
            </Modal>
          )}
        </Formik>
      </div>
    </div>
  );
};
